import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import AdminApp from "./admin/AdminApp";
import { registerServiceWorker } from "./lib/pwa";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("Brak kontenera #root");

// Panel konsultanta i proces kandydata to dwa różne światy — dzielimy je na wejściu.
const isAdmin = window.location.pathname.startsWith("/admin");

createRoot(container).render(
  <StrictMode>{isAdmin ? <AdminApp /> : <App />}</StrictMode>,
);

/**
 * Ekran powitalny zdejmujemy dopiero po pierwszym malowaniu aplikacji.
 *
 * Dwa `requestAnimationFrame` zamiast `setTimeout`: pierwszy wypada przed
 * malowaniem klatki, drugi po nim — czyli dokładnie wtedy, gdy pod spodem jest
 * już coś do pokazania. Stały czas byłby zgadywaniem: na szybkim łączu trzymałby
 * ekran dłużej, niż trzeba, a na wolnym telefonie zdjąłby go za wcześnie i
 * odsłonił puste płótno.
 */
const wejscie = document.getElementById("wejscie");
if (wejscie) {
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      wejscie.classList.add("znika");
      // Element znika z drzewa po wygaszeniu; `transitionend` nie wystarcza,
      // bo przy wyłączonych animacjach przejście w ogóle się nie odpala.
      window.setTimeout(() => wejscie.remove(), 400);
    }),
  );
}

registerServiceWorker();
